export enum ActivationStatus {
  NOT_ACTIVE = 'Não ativo',  // Não foi ativado hoje
  ACTIVE = 'Ativo',          // Já foi ativado hoje
  INACTIVE = 'Inativo',      // Esgotou ou venceu
}
